import React, { useState, useEffect } from 'react';
import '../css/components/ManageProfile.css';
import Loading from '../general/Loading';

const StaffDashboard = ({ userData, setResponse }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_name: '',
    mobile: '',
    permission: '',
    role: '',
    pass: '',
  });

  const [parsedPermissions, setParsedPermissions] = useState([]);

  useEffect(() => {
    if (userData) {
      setFormData({
        user_name: userData.name || '',
        mobile: userData.mobile || '',
        permission: userData.permission || '',
        role: userData.role || '',
        pass: userData.pass || '',
      });

      // Parse permission JSON safely
      try {
        const perms = JSON.parse(userData.permission);
        if (Array.isArray(perms)) {
          setParsedPermissions(perms);
        }
      } catch (err) {
        console.error('Failed to parse permissions:', err);
        setParsedPermissions([]);
      }
    }
  }, [userData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
return (
  <>
    <section className="container py-4">
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-header text-white py-3">
          <h4 className="mb-0" style={{color:"#111111"}}>My Profile Details</h4>
        </div>

        <div className="card-body">
          <div className="row g-4">
            {[
              { label: "Your Name", name: "user_name" },
              { label: "Mobile", name: "mobile", type: "tel" },
              { label: "Role", name: "role" },
              { label: "Password", name: "pass", type: "password" },
            ].map(({ label, name, type = "text" }) => (
              <div className="col-md-6" key={name}>
                <label className="form-label fw-semibold">
                  {label}
                </label>

                <input
                  type={type}
                  className="form-control"
                  name={name}
                  value={formData[name]}
                  onChange={handleInputChange}
                  readOnly
                />
              </div>
            ))}

            {/* Permissions */}
            <div className="col-6">
              <label className="form-label fw-semibold">
                Permissions
              </label>

              <div className="border rounded-3 p-3 bg-light">
                {parsedPermissions.length > 0 ? (
                  parsedPermissions.map((perm, idx) => (
                    <span
                      key={idx}
                      className="badge bg-success me-2 mb-2 px-3 py-2"
                    >
                      {perm}
                    </span>
                  ))
                ) : (
                  <span className="text-muted">
                    No permissions assigned.
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {loading && <Loading setLoading={setLoading} />}
  </>
);
  // return (
  //   <>
  //     <section className='my-4'>
  //       <div className='px-4'>
  //         <p className='page-title'>My Profile Details</p>

  //         <div className='row g-3 mt-1'>
  //           {[
  //             { label: 'Your Name', name: 'user_name' },
  //             { label: 'Mobile', name: 'mobile', type: 'tel' },
  //             { label: 'Role', name: 'role' },
  //             { label: 'Password', name: 'pass' },
  //           ].map(({ label, name, type = 'text' }) => (
  //             <div key={name}>
  //               <div className='profile-input px-0'>
  //                 <label className='profile-label'>{label}</label>
  //                 <input
  //                   type={type}
  //                   className='profile-control'
  //                   name={name}
  //                   value={formData[name]}
  //                   onChange={handleInputChange}
  //                   // disabled={!isEditing}
  //                 />
  //               </div>
  //             </div>
  //           ))}

  //           {/* PERMISSIONS DISPLAY */}
  //           <div className='col-12'>
  //             <div className='profile-input py-3'>
  //               <label className='profile-label'>Permissions</label>
  //               <div className='permission-list'>
  //                 {parsedPermissions.length > 0 ? (
  //                   parsedPermissions.map((perm, idx) => (
  //                     <span key={idx} className='badge fw-semibold bg-success py-2 me-2'>
  //                       {perm}
  //                     </span>
  //                   ))
  //                 ) : (
  //                   <span className='text-muted'>No permissions assigned.</span>
  //                 )}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </section>

  //     {loading && <Loading setLoading={setLoading} />}
  //   </>
  // );
};

export default StaffDashboard;
